import { render } from "./AllowCourseAccessAction.vue?vue&type=template&id=36cf4807"
import script from "./AllowCourseAccessAction.vue?vue&type=script&lang=js"
export * from "./AllowCourseAccessAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__